// extracted by mini-css-extract-plugin
module.exports = {"Main":"Layout__Main__3uOPW","ticker":"Layout__ticker__25AJS","blockScroll":"Layout__blockScroll__1iyq0"};